import { render, staticRenderFns } from "./PeopleCard.vue?vue&type=template&id=392287f8&scoped=true&"
import script from "./PeopleCard.js?vue&type=script&lang=js&"
export * from "./PeopleCard.js?vue&type=script&lang=js&"
import style0 from "./PeopleCard.scss?vue&type=style&index=0&id=392287f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392287f8",
  null
  
)

export default component.exports